var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-load-image",
    { class: _vm.wrapperClass },
    [
      _c("template", { slot: "image" }, [
        _c("img", {
          class: _vm.imageClass,
          attrs: { alt: _vm.alt, src: _vm.src },
          on: {
            load: _vm.imageLoad,
            error: _vm.handleImageError,
            click: _vm.click
          }
        })
      ]),
      _vm._v(" "),
      _c("template", { slot: "preloader" }, [
        _c("div", { staticClass: "wf-load-image-status" }, [
          _c(
            "div",
            { staticClass: "spinner-border", attrs: { role: "status" } },
            [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
          )
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "error" }, [
        _c("div", { class: "wf-load-image-status " + _vm.noImageStyles }, [
          _c("span", { staticClass: "png-icon png-icon-icons-glyph--k-info" }),
          _vm._v(" "),
          _c("p", { staticClass: "my-2 text-center" }, [
            _vm._v("\n        Sorry - this image is unavailable.\n      ")
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }